import { Route } from "@angular/router";

import { authGuard } from "@core/guards/auth.guard";

import { OrganizationRoutesConstants } from "./organization.routes.constants";

/**
 * Routes available for ORGANIZATION_USER role.
 * Keep this intentionally limited vs `organizationAdminRoutes`.
 */
export const organizationUserRoutes: Route = {
  path: "organization",
  canActivate: [authGuard],
  children: [
    {
      path: OrganizationRoutesConstants.MY_ORGANIZATION,
      loadComponent: () =>
        import("../components/my-organization/my-organization.component").then((m) => m.MyOrganizationComponent),
      title: "My Organization"
    },
    {
      path: "**",
      redirectTo: OrganizationRoutesConstants.MY_ORGANIZATION
    }
  ]
};
